import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import Home from '../pages/Home';
import About from '../pages/About';
import Competitions from '../pages/Competitions';
import Records from '../pages/Records';
import Contact from '../pages/Contact';
import NotFound from '../pages/NotFound';

const SUPPORTED_LANGUAGES = ['el', 'en'];

function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to="/el" replace />;
  }

  return <Layout />;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/el" replace />} />
      <Route path="/:lang" element={<LanguageWrapper />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="competitions" element={<Competitions />} />
        <Route path="records" element={<Records />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
